import driversReducer from './driversReducer';

export default driversReducer;
